export const TABLE_HEAD = {
  FY: 'FY',
  UNIT: 'UNIT',
  AUDIT_STATUS: 'AUDIT_STATUS',
  TYPE: 'TYPE',
  LEGAL_REGULATION: 'LEGAL_REGULATION',
  SOURCE: 'SOURCE',
  METHOD: 'METHOD',
}

const getColumn = (rawData) => {
  let columns = []
  rawData.forEach((item) => {
    if (item.reportFormId !== columns[columns.length - 1]?.reportFormId) {
      columns.push({
        colId: `RatioName-${item.realYear}`,
        reportFormId: item.reportFormId,
      })
    }
    columns.push({
      colId: String(item.realYear),
      fiscalYearEnd: item.fiscalYearEnd,
      isAudit: item.isAudit,
      isConsolidate: item.isConsolidate,
      isDirect: item.isDirect,
      isSingleEntity: item.isSingleEntity,
      realYear: item.realYear,
      reportFormId: item.reportFormId,
      reportFormCode: item.reportFormCode,
      sourceOrganizationName: item.sourceOrganizationName,
    })
  })
  return columns
}

const getData = (rawData, type) => {
  const result = {}

  rawData.forEach((item) => {
    item[type].forEach((row, index) => {
      if (!result[index]) {
        result[index] = {}
      }
      result[index][item.realYear] = row
    })
  })

  return result
}

export const convertData = (rawData = []) => {
  const columns = getColumn(rawData)
  const balanceSheets = getData(rawData, 'balanceSheets')
  const incomeStatements = getData(rawData, 'incomeStatements')
  const cashFlows = getData(rawData, 'cashFlows')

  return { columns, balanceSheets, incomeStatements, cashFlows }
}

export const getCellStyle = (fieldStyle = '', isRatioNameCell) => {
  const style = {
    paddingTop: 2,
    paddingBottom: 2,
    paddingLeft: 12,
    paddingRight: 12,
  }

  if (isRatioNameCell) {
    if (fieldStyle.includes('T')) {
      style.paddingLeft = (fieldStyle.split('T').length - 1) * 24 + 12
    }
  } else {
    style.textAlign = 'right'
  }

  if (fieldStyle.includes('B')) {
    style.fontWeight = 600
  }

  if (fieldStyle.includes('P')) {
    style.textTransform = 'uppercase'
  }

  if (fieldStyle.includes('U')) {
    style.textDecoration = 'underline'
  }

  if (fieldStyle.includes('I')) {
    style.fontStyle = 'italic'
  }

  if (fieldStyle.includes('L')) {
    const borderWidth = fieldStyle.split('L').length - 1
    style.borderTop = `${borderWidth}px solid #3a414b`
  }

  if (fieldStyle.includes('M') || fieldStyle.includes('L')) {
    const borderTopWidth = fieldStyle.split('L').length - 1
    const borderBottomWidth = fieldStyle.split('M').length - 1
    style.borderStyle = 'solid'
    style.borderColor = '#3a414b'
    style.borderWidth = `${borderTopWidth}px 0px ${borderBottomWidth}px 0px`
  }

  return style
}
